<template>
  <v-row class="notifications-display-container">
    <!-- :absolute="isNotAdmin" -->
    <v-snackbar
      v-if="notifications"
      v-model="message"
      :color="messageType"
      :timeout="timeout"
      absolute
      min-width="100%"
      max-width="100%"
      tile
      location="top"
      class="elevation-0"
      content-class="text-center no-overflow"
    >
      <span v-html="getNotificationContent(notifications)"></span>

      <template #actions="{ attrs }">
        <v-btn
          icon
          :loading="loading"
          v-bind="attrs"
          @click="manageNotification(notifications)"
          class=""
        >
          <v-icon
            v-if="
              notifications.audience &&
              !notifications.audience.includes('permanent')
            "
            >mdi-close</v-icon
          >
        </v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>
<script>
  import db from '@/firebase/init'
  import { mapGetters } from 'vuex'

  export default {
    name: 'DisplayNotifications',
    props: ['notificationbackdoor', 'isNotAdmin', 'user'],
    data() {
      return {
        notifications: [],
        allNotifications: [],
        message: false,
        timeout: -1,
        loading: false,
      }
    },
    computed: {
      churchid() {
        return this.$store.getters['AppData/cid']
      },
      messageType() {
        // console.log(this.notifications.length)
        if (this.notifications.messagetype == 'notify') return '#592892'
        if (this.notifications.messagetype == 'warning') return '#a5d867'
        if (this.notifications.messagetype == 'critical') return '#592892'
        return this.notifications.messagetype
      },
      ...mapGetters('AppData', [
        'getActiveInternalNotifications',
        'getAllInternalNotifications',
        'getFeatures',
      ]),
      ...mapGetters('UserData', ['getRoles']),
    },
    watch: {
      notificationbackdoor: function (newVal, oldVal) {
        // watch it
        // console.log('notificationbackdoor changed: ', newVal, ' | was: ', oldVal)
        if (newVal > oldVal) {
          this.getNotifications()
        }
      },
      // Watch for user to become available
      user: {
        handler: function (newVal) {
          if (newVal && newVal.uid && this.$store.state.AppData?.cid) {
            this.getNotifications()
          }
        },
        immediate: false,
        deep: false,
      },
      getActiveInternalNotifications: function (newVal) {
        // save Promise result in local state
        // console.log('newVal ', newVal)

        if (Array.isArray(newVal) && newVal.length) {
          const userRoles = this.$store.getters['UserData/getRoles']
          const isSupperAdmin = this.checkAuthorization(['superAdmin'])
          const flattened = newVal.reduce(
            (acc, curVal) => acc.concat(curVal),
            []
          )
          // console.log('newVal 1 ', flattened)

          if (!isSupperAdmin && flattened.length > 0) {
            // make sure this feature is turned on or set for testers only
            if (
              (this.getRoles && this.getRoles.includes('tester')) ||
              (this.getFeatures && this.getFeatures.includes('notifications'))
            ) {
              const hasAudience = flattened.filter((el) => {
                //first check to make sure it is NOT a notify
                if (el.messagetype !== 'notify')
                  return userRoles.some((r) => el.audience.includes(r))
              })

              // hasAudience.sort((a, b) => (a.created < b.created) ? 1 : -1)

              // give priority to the All Churches message type
              hasAudience.sort(function (a, b) {
                if (
                  a.audience.includes('allchurches') ===
                  b.audience.includes('allchurches')
                ) {
                  // Date is only important when audiences are the same (false)
                  return b.created - a.created
                }
                return a.audience.includes('allchurches') <
                  b.audience.includes('allchurches')
                  ? 1
                  : -1
              })

              this.notifications = hasAudience[0]
              this.message = true
              this.$emit('getActiveNotifications', hasAudience)
              this.loading = false
            }
          } else {
            // console.log('else ')
            this.notifications = []
            this.message = false
            this.loading = false
            this.$emit('getActiveNotifications', this.notifications)
          }
        } else {
          // console.log('else ')
          this.notifications = []
          this.message = false
          this.loading = false
          this.$emit('getActiveNotifications', this.notifications)
        }
      },
      getAllInternalNotifications: function (newVal) {
        if (Array.isArray(newVal) && newVal.length) {
          const userRoles = this.$store.getters['UserData/getRoles']
          const isSupperAdmin = this.checkAuthorization(['superAdmin'])
          const flattened = newVal.reduce(
            (acc, curVal) => acc.concat(curVal),
            []
          )

          if (!isSupperAdmin && flattened.length > 0) {
            // make sure this feature is turned on or set for testers only
            if (
              (this.getRoles && this.getRoles.includes('tester')) ||
              (this.getFeatures && this.getFeatures.includes('notifications'))
            ) {
              const hasAudience = flattened.filter((el) => {
                return userRoles.some((r) => el.audience.includes(r))
              })

              // give priority to the All Churches message type
              // hasAudience.sort(function(a, b) {
              //     if (a.audience.includes('allchurches') === b.audience.includes('allchurches')) {
              //         // Date is only important when audiences are the same (false)
              //         return b.created - a.created;
              //     }
              //     return a.audience.includes('allchurches') < b.audience.includes('allchurches') ? 1 : -1;
              // })

              hasAudience.sort((a, b) => (a.created < b.created ? 1 : -1))

              this.allNotifications = hasAudience[0]
              this.$emit('getAllNotifications', hasAudience)
            }
          } else {
            this.allNotifications = []
            this.$emit('getAllNotifications', this.allNotifications)
          }
        }
      },
    },
    methods: {
      manageNotification(notification) {
        this.loading = true
        // console.log(notification, this.user)
        db.collection('notificationsread')
          .add({
            notificationid: notification.id,
            userid: this.user.uid,
            created: Date.now(),
          })
          .then(() => {
            this.getNotifications()
          })
          .catch((err) => {
            console.log(err)
          })
      },
      getNotifications() {
        // Check if store is ready
        if (!this.$store.state.UserData || !this.$store.state.AppData) {
          return
        }

        // Only proceed if we have both cid and user
        const cid = this.$store.getters['AppData/cid']
        const user = this.user

        if (!cid || !user) {
          return
        }

        this.$store.dispatch('AppData/resetActiveInternaleNotifications', [], {
          root: true,
        })
        this.$store.dispatch(
          'AppData/getActiveInternalNotifications',
          {
            cid: cid,
            user: user,
          },
          { root: true }
        )

        this.$store.dispatch('AppData/resetAllInternaleNotifications', [], {
          root: true,
        })
        this.$store.dispatch(
          'AppData/getAllInternalNotifications',
          {
            cid: this.$store.getters['AppData/cid'],
            user: this.user,
          },
          { root: true }
        )
      },
      checkAuthorization(permissions) {
        const userRoles = this.$store.getters['UserData/getRoles']
        if (permissions && userRoles) {
          const hasRole = permissions.filter(() =>
            userRoles.some((role) => permissions.includes(role))
          )
          if (hasRole && hasRole.length > 0) return true
        }
        return false
      },
      getNotificationContent(item) {
        // Get the current locale (from URL param)
        const currentLang = this.$route.params.locale || 'en'

        // First, look for translated content in variants
        if (item.variants && item.variants.default) {
          const variants = item.variants.default

          // Try to get content for current language
          if (variants[currentLang]) {
            return variants[currentLang]
          }
        }

        // Second, if current language matches source language, use original content
        if (currentLang === item.sourceLocale) {
          return item.notification || ''
        }

        // Third, fallback to English variant if available
        if (
          item.variants &&
          item.variants.default &&
          item.variants.default.en
        ) {
          return item.variants.default.en
        }
        // Fallback to original notification content
        return item.notification || ''
      },
    },
    created() {
      this.getNotifications()
    },
  }
</script>
<style scoped>
  /* .notifications-display-container {
    position: absolute;
    z-index: 999;
    width: 100%;
    justify-content: center;
} */
  .v-snack--absolute {
    z-index: 100;
    position: fixed;
  }
  .the-alert :deep(p, ) .v-snack :deep(p) {
    margin-bottom: 0;
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .notifications-display-container :deep(.v-snack__wrapper) {
    margin: 0;
    height: 38px;
    max-height: 38px;
    min-height: 38px;
    width: 100%;
    max-width: 100%;
  }
  .notifications-display-container :deep(.no-overflow) {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-bottom: 0;
    padding-top: 0;
  }
</style>
